module.exports = __webpack_public_path__ + "static/media/costa.71699516.png";